import React from "react";
import { IconLogout2, IconArrowLeft } from "@tabler/icons-react";

interface FtuTopNavProps {
  canGoBack: boolean;
  onBack: () => void;
  onExit: () => void;
  showProgress: boolean;
  currentStep: number;
  maxSteps: number;
}

const FtuTopNav: React.FC<FtuTopNavProps> = ({
  canGoBack,
  onBack,
  onExit,
  showProgress,
  currentStep,
  maxSteps,
}) => {
  return (
    <nav className="w-full max-w-[680px] mx-auto flex items-center justify-between px-4 py-6 bg-[#fcf9f7]">
      {/* Previous Button - ALWAYS RENDERED to prevent layout shift */}
      <div className="w-[92px]">
        {canGoBack && (
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center gap-1.5 bg-transparent border-0 cursor-pointer transition-opacity hover:opacity-70"
            aria-label="Go back to previous question"
          >
            <IconArrowLeft size={16} strokeWidth={2} className="text-[#1e1e1e]" />
            <span 
              className="font-medium text-base text-[#1e1e1e]"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Previous
            </span>
          </button>
        )}
      </div>

      {/* Progress Tracker - ALWAYS takes up space to prevent layout shift */}
      <div className="w-[150px] flex items-center justify-center">
        {showProgress && (
          <div 
            className="flex items-center justify-center bg-[#f5ecea] rounded-[60px] py-2.5 w-full"
            aria-live="polite"
          >
            <span 
              className="text-sm text-[#1e1e1e] text-center"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              <span className="font-bold">{currentStep}</span>/{maxSteps}
            </span>
          </div>
        )}
      </div>

      {/* Exit Button - ALWAYS RENDERED */}
      <button
        type="button"
        onClick={onExit}
        className="inline-flex items-center gap-1.5 w-16 justify-end bg-transparent border-0 cursor-pointer transition-opacity hover:opacity-70"
        aria-label="Exit and log out"
      >
        <IconLogout2 size={24} strokeWidth={1.5} className="text-[#1e1e1e]" />
        <span 
          className="font-medium text-base text-[#1e1e1e]"
          style={{ fontFamily: 'DM Sans, sans-serif' }}
        >
          Exit
        </span>
      </button>
    </nav>
  );
};

export default FtuTopNav;